module.exports = __webpack_public_path__ + "static/img/3.f3dd58f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/detail/common/document/1/3.png
// module id = WvQM
// module chunks = 1